<section class="grid gap-4">
  <div class="flex items-center justify-between gap-3">
    <page-title title="New request" /><a mat-stroked-button routerLink="/interventions">Back to interventions</a>
  </div>
  <wizard-steps-nav [steps]="steps" active="NewRequest" [interactive]="false" />
  <new-request-form [busy]="store.saving()" [interventionTypes]="store.interventionTypes()" (submitted)="save($event)" />
</section>
